import { Component, h, Prop } from '@stencil/core';
import { PageNodeCTA } from 'interfaces/PageNode';

@Component({
    tag: 'app-nav-cta',
    shadow: false,
})
export class AppNavCta {

    @Prop() CTA: PageNodeCTA

    render() {
        return (
            <div class="cta" style={this.getImageStyles()}>
                <div class="cta-content">
                    <div class="cta-label">{this.CTA.Label}</div>
                    <div class="cta-title">{this.CTA.Title}</div>
                    {Boolean(this.CTA.Description) && <div class="cta-description">{this.CTA.Description}</div>}
                    <a href={this.CTA.LinkUrl} aria-label={this.CTA.LinkTitle} class="arrow-link__underline">
                        {this.CTA.LinkTitle}<svg>
                            <use href="/themes/custom/qsci/frontend/www/assets/icon/sheets/icons.svg#arrow-right"></use>
                        </svg>
                    </a>
                </div>
            </div>
        );
    }

    getImageStyles() {
        const styles: any = {
            backgroundImage: `url('${this.CTA.ImgUrl}')`,
        };

        // Check for support for -webkit-image-set
        if (window.CSS && window.CSS.supports && window.CSS.supports('background-image', `-webkit-image-set(url("${this.CTA.ImgUrlWebp}") 1x)`)) {
            styles.backgroundImage = `-webkit-image-set(url('${this.CTA.ImgUrlWebp}') 1x)`;
        }

        return styles;
    }

}